import { render } from "./cloudError.vue?vue&type=template&id=2ddf9128&scoped=true"
import script from "./cloudError.vue?vue&type=script&lang=js"
export * from "./cloudError.vue?vue&type=script&lang=js"

import "./cloudError.vue?vue&type=style&index=0&id=2ddf9128&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddf9128"]])

export default __exports__